import React, { Component } from 'react'
import FilterOptions from './FilterOptions'
import Switch from 'react-switch'
import {
  getDefaultFilterOptions,
  saveFilterOptions,
  getPreviewModeEnabled,
  setPreviewModeEnabled,
  loadFilterOptions
} from '../../services/liveview'

export default class TopBar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      toggleFilterMenu: false,
      previewModeEnabled: getPreviewModeEnabled(),
      checked: false
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {}

  handleChange(checked) {
    this.setState({ checked })
  }

  handlePreviewModeChange = event => {
    const isPreviewModeEnabled = !this.state.previewModeEnabled

    //Get filter values
    const filterOptions = loadFilterOptions()

    localStorage.clear()
    sessionStorage.clear()

    setPreviewModeEnabled(!this.state.previewModeEnabled)

    //Reapply filter options
    saveFilterOptions(filterOptions)

    this.setState({
      previewModeEnabled: isPreviewModeEnabled
    })
    setTimeout(window.location.reload.bind(window.location), 500)
  }

  componentDidUpdate(prevProps) {}

  toggleFilterMenu = () => {
    this.setState({
      toggleFilterMenu: !this.state.toggleFilterMenu
    })
  }

  render() {
    return (
      <div className="top-bar">
        <div
          className={this.state.previewModeEnabled ? 'bar preview' : 'bar live'}
        >
          <div className="mode">
            {this.props.showPreviewOptions == true ? (
              <div className="mode-item">
                <span
                  className={
                    !this.state.previewModeEnabled ? 'text-greyed' : ''
                  }
                >
                  Preview
                </span>
              </div>
            ) : null}

            {this.props.showPreviewOptions == true ? (
              <div className="mode-item">
                <Switch
                  onColor={
                    this.state.previewModeEnabled ? '#fd9b1e' : '#1466b5'
                  }
                  offColor={
                    this.state.previewModeEnabled ? '#fd9b1e' : '#1466b5'
                  }
                  uncheckedIcon={false}
                  checkedIcon={false}
                  onChange={this.handlePreviewModeChange}
                  checked={!this.state.previewModeEnabled}
                />
              </div>
            ) : (
              ''
            )}

            <div className="mode-item">
              <span
                className={this.state.previewModeEnabled ? 'text-greyed' : ''}
              >
                Live
              </span>
            </div>
          </div>
          <div className="options">
            <div className="user-info">
              <button
                className="header-button header-icon header-cog"
                onClick={this.toggleFilterMenu}
              />
            </div>
          </div>
        </div>
        {this.state.toggleFilterMenu == true && <FilterOptions />}
      </div>
    )
  }
}
